import Select from 'react-select';
import { Theme, useTheme } from '@mui/material/styles';
import { getCommonInputProps } from '../../../../../../ui/layout/form/input/BaseInputLayout';
import { Option as OptionType, DefaultDropdownLayoutProps } from 'framework/form';
import { getVarsPalette } from 'framework/ui/themes';
import DropDownFilterInputOption from '../DropDownFilterInputOption';

export const getSelectStyles = (theme: Theme) => {
  const palette = getVarsPalette(theme);

  return {
    control: () => ({ display: 'none' }),
    menu: () => ({}),
    menuList: (provided: CSSStyleSheet) => ({ ...provided, padding: 0 }),
    option: (provided: CSSStyleSheet, state: Dictionary<boolean>) => ({
      ...provided,
      background: state.isSelected ? `${palette.background.primary} !important` : palette.common.white,
      color: palette.text.primary,
      display: 'flex',
      alignItems: 'center',
      gap: 1,
      ...(state.isDisabled && {
        opacity: 0.5,
        pointerEvents: 'none',
      }),
    }),
  };
};

interface SelectLayoutProps extends DefaultDropdownLayoutProps {
  selectedValues?: OptionType[];
}

const SelectLayout = ({
  label,
  options = [],
  errorMessages,
  multiple = false,
  onChangeCallback = () => {},
  value: initialValue = '',
  source,
  selectedValues,
  isLoading = false,
  ...defaultLayoutProps
}: SelectLayoutProps) => {
  const theme = useTheme();
  const selectStyles = getSelectStyles(theme);

  /**
   * Dropdown onChangeCallback accepts different value format depending on if it's `multiple` or not.
   * @params {array | object} if `multiple` set to true, newValue has object type otherwise it is array of objects
   */
  const onChange = (newValues: OptionType | OptionType[]) => {
    let target;

    if (multiple) {
      target = {
        options: (newValues as OptionType[]).map(option => ({
          ...option,
          selected: true,
        })),
      };
    } else {
      target = {
        value: (newValues as OptionType).value,
      };
    }

    onChangeCallback({ target });
  };

  options = options.map(option => {
    if ('disabled' in option) {
      return { ...option, isDisabled: option.disabled };
    }
    return option;
  });

  return (
    <Select
      {...getCommonInputProps({ ...defaultLayoutProps, source }, false)}
      autoFocus
      backspaceRemovesValue={false}
      components={{ DropdownIndicator: null, IndicatorSeparator: null, Option: DropDownFilterInputOption as any }}
      controlShouldRenderValue={false}
      hideSelectedOptions={false}
      isClearable={false}
      isLoading={isLoading}
      styles={selectStyles as any}
      tabSelectsValue={false}
      isMulti={multiple}
      value={selectedValues}
      onChange={onChange as any}
      options={options}
      menuIsOpen
    />
  );
};

export default SelectLayout;
